import { Link } from "react-router-dom";
import { useBookingLink } from "../lib/useBookingLinks";
import { treatmentForArticle } from "../data/article-treatment";
import { trackSchedule } from "../lib/tracking";

// In-article call to action that books the treatment the article is about.
export const ArticleBookCard = ({ article }) => {
  const t = treatmentForArticle(article);
  const book = useBookingLink(t.name);
  return (
    <aside className="not-prose my-14 border border-neutral-950 bg-[hsl(var(--stone))] p-8 text-center md:p-10" data-testid="article-book-card">
      <p className="text-[10px] uppercase tracking-[0.35em] text-neutral-500">Ready for results?</p>
      <p className="font-vogue mt-3 text-3xl leading-tight text-neutral-950" data-testid="article-book-treatment">{t.label}</p>
      <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a href={book} target="_blank" rel="noreferrer" onClick={trackSchedule} className="btn-ink" data-testid="article-book-treatment-btn">Book This Treatment</a>
        <Link to={t.page} className="link-under" data-testid="article-treatment-details-link">Details & Pricing</Link>
      </div>
    </aside>
  );
};
